/**
 * Microsoft Clarity session-recording config.
 *
 * Vue parity: `RW-ERP-Service/src/types/constants/global-constants.ts`
 * (`MICROSOFT_CLARITY_ID`), which is environment-selected via Vue's
 * Vite-only `isProductionServer` (`VITE_BASE_URL === PRODUCTION_SERVER_URL`).
 * This app has no such build-time flag, so production is re-derived from
 * the resolved API host instead, via the shared `utils/env.ts`
 * `isProductionServer()` util.
 */
import { isProductionServer } from 'utils/env';

const CLARITY_PROJECT_ID_PROD = 'xynq01o049';
const CLARITY_PROJECT_ID_DEV = 'y5tj3e28xu';

export const MICROSOFT_CLARITY_ID = isProductionServer()
  ? CLARITY_PROJECT_ID_PROD
  : CLARITY_PROJECT_ID_DEV;

/**
 * Emails on this domain get extra Clarity tags (`email`, `user`).
 * Vue parity: `main.ts:56`.
 */
export const CLARITY_TAGGED_EMAIL_DOMAIN = '@restaurantware.com';
